import qs from "qs";

import { axiosWithAuth, history } from "helpers";

export const usersService = {
	addUser,
	bulkUpdateUserPermissions,
	confirmPhoneChange,
	getAffectedUsers,
	getHierarchy,
	getUser,
	getUserProfileData,
	getUsers,
	initializeEmailChange,
	initializeMobilePhoneChange,
	resetUserPassword,
	updateUserInfo,
	updateUserProfileData,
	updateUserStatus,
};

const API_URL = process.env.REACT_APP_API_URL;

const PAGE_SIZE = 50;

function getUsers({ page, filters, sortBy }) {
	return axiosWithAuth({
		url: `${API_URL}/api/users`,
		method: "GET",
		params: {
			page_index: page,
			page_size: PAGE_SIZE,
			full_name: filters?.fullName,
			email: filters?.email,
			phone_number: filters?.phoneNumber,
			roles: filters?.role?.value,
			is_active: filters?.isActive?.value,
			agent_office: filters?.agentOffice,
			sort_type: sortBy?.id || undefined,
			ascending: sortBy?.id ? sortBy?.desc : undefined,
		},
	});
}

function updateUserStatus({ id, status }) {
	return axiosWithAuth({
		url: `${API_URL}/api/users/${id}/status`,
		method: "PUT",
		data: { status },
	});
}

function getUser(id) {
	return axiosWithAuth(
		{ url: `${API_URL}/api/users/${id}` },
		handleGetUserError,
	);
}

function handleGetUserError(error) {
	if (error.response && error.response.status === 403) {
		history.push("/system-setup/users");
	}
}

function addUser(user) {
	return axiosWithAuth({
		method: "POST",
		data: JSON.stringify(user),
		url: `${API_URL}/api/users`,
	});
}

function bulkUpdateUserPermissions(userId, permissionIds) {
	const options = {
		method: "PUT",
		params: { permission_ids: permissionIds },
		url: `${API_URL}/api/users/${userId}/permissions/bulk_update`,
	};

	return axiosWithAuth(options);
}

function getHierarchy({ id }) {
	return axiosWithAuth({
		url: `${API_URL}/api/users/${id}/hierarchy`,
	});
}

function updateUserInfo({ id, ...userValues }) {
	return axiosWithAuth({
		method: "PUT",
		data: userValues,
		url: `${API_URL}/api/users/${id}`,
	});
}

function resetUserPassword({ userId }) {
	return axiosWithAuth({
		method: "POST",
		url: `${API_URL}/api/users/${userId}/send_password_reset`,
	});
}

function getUserProfileData() {
	const options = {
		method: "GET",
		url: `${API_URL}/api/me/profile`,
	};

	return axiosWithAuth(options);
}

function updateUserProfileData(data) {
	const options = {
		method: "PUT",
		url: `${API_URL}/api/me/profile`,
		data,
	};

	return axiosWithAuth(options);
}

function initializeEmailChange(data) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/me/initialize_email_change`,
		data,
	};

	return axiosWithAuth(options);
}

function initializeMobilePhoneChange(data) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/me/initialize_mobile_phone_change`,
		data,
	};

	return axiosWithAuth(options);
}

function confirmPhoneChange(code) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/me/confirm_mobile_phone_change`,
		params: {
			code,
		},
		paramsSerializer: params =>
			qs.stringify(params, { arrayFormat: "repeat" }),
	};

	return axiosWithAuth(options);
}

function getAffectedUsers({ companyId, domains }) {
	const options = {
		method: "GET",
		params: {
			domains,
		},
		paramsSerializer: params =>
			qs.stringify(params, { arrayFormat: "repeat" }),
		url: `${API_URL}/api/companies/${companyId}/whitelisted_email_domains/affected_users`,
	};

	return axiosWithAuth(options);
}
